export enum SourceEnum {
  WEB = 'WEB',
  RESPONSIVE = 'RESPONSIVE',
}